import { supabase } from "@/lib/supabaseClient";

type InvokeOptions = Parameters<typeof supabase.functions.invoke>[1];
type InvokeResult<T> = Awaited<ReturnType<typeof supabase.functions.invoke<T>>>;

export async function invokeProtectedFunction<T = any>(
  name: string,
  options?: InvokeOptions,
): Promise<InvokeResult<T>> {
  return supabase.functions.invoke<T>(name, options);
}
